import React from 'react';

const Logo = ({ ...props }: any) => (
  <img {...props} src="/images/logo.png" alt="USEFULL logo" />
);

export default Logo;
